/*
 * タイムセール（旧PREMIUM SALE）ラインナップを割引率の高い順に並べ替える（クライアント側）。
 * Liquidでは計算値（compare_at と price の差率）でソートできないためJSで実施。
 *   - two_row_scroll: 上段＝高割引を左から / 下段＝次点の割引。
 *   - slider / grid: 単純に割引率降順。
 * カードは data-ps-discount（Liquidが付与）を持ち、ノードは move（appendChild）で
 * 移動するため quick-add 等の既存リスナー・カスタム要素は維持される。loop無効前提。
 */
(function () {
  function discountOf(el) {
    var v = parseInt(el.getAttribute('data-ps-discount'), 10);
    return isNaN(v) ? -1 : v;
  }

  // 安定降順ソート（同率は元の順序を維持）
  function sortDesc(items) {
    return items
      .map(function (el, i) { return { el: el, d: discountOf(el), i: i }; })
      .sort(function (a, b) { return b.d - a.d || a.i - b.i; })
      .map(function (o) { return o.el; });
  }

  function childItems(parent, cls) {
    return Array.prototype.slice.call(parent.children).filter(function (c) {
      return c.classList && c.classList.contains(cls) && c.hasAttribute('data-ps-discount');
    });
  }

  function sortSection(section) {
    if (!section) return;

    // slider / two_row_scroll: 各 .swiper を個別処理（PC/モバイルで複数存在し得る）
    section.querySelectorAll('.swiper').forEach(function (sw) {
      var wrapper = sw.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      var twoRowItems = Array.prototype.slice.call(
        wrapper.querySelectorAll('.ftr-two-row-item[data-ps-discount]')
      );
      if (twoRowItems.length) {
        var slides = Array.prototype.slice.call(wrapper.querySelectorAll('.ftr-two-row-slide'));
        if (!slides.length) return;
        var sorted = sortDesc(twoRowItems);
        // 列ごとに上段→下段の順で左から配置（列0上=最高, 列0下=次点, 列1上=3番目…）
        for (var k = 0; k < slides.length; k++) {
          var top = sorted[2 * k];
          var bottom = sorted[2 * k + 1];
          if (top) slides[k].appendChild(top);
          if (bottom) slides[k].appendChild(bottom);
        }
      } else {
        var slideItems = childItems(wrapper, 'swiper-slide');
        if (!slideItems.length) return;
        sortDesc(slideItems).forEach(function (el) { wrapper.appendChild(el); });
      }

      var carousel = sw.closest('slider-carousel');
      if (carousel && carousel.swiper && typeof carousel.swiper.update === 'function') {
        carousel.swiper.update();
      }
    });

    // grid: Swiperなし
    section.querySelectorAll('.pakari-product-grid').forEach(function (grid) {
      var items = childItems(grid, 'grid__item');
      if (items.length) sortDesc(items).forEach(function (el) { grid.appendChild(el); });
    });
  }

  function run() {
    document.querySelectorAll('[data-ps-refresh]').forEach(sortSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // キャッシュ回避スワップ（premium-sale-refresh.js）後の再ソート
  document.addEventListener('ps:section-refreshed', function (e) {
    if (e && e.target && e.target.nodeType === 1) sortSection(e.target);
    else run();
  });
})();
